import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { subscribe } from '../lib/klayvio-subscribe'

export default component((node) => {
  const form = node
  const listId = $(form).find('[name="list_id"]').val()

  $(form).on('submit', function (e) {
    e.preventDefault()
    const email = $(form).find('[type="email"]').val()
    $(form).find('button[type="submit"]').attr('aria-busy', 'true')
    subscribe(listId, email).then((res) => {
      if (res.success) {
        const successMessage = document.querySelector('[newsletter-success]')
        $(successMessage).show(true)
        successMessage.focus()
        $(form).find('button[type="submit"]').attr('aria-busy', 'false')
        $(form).find('[type="email"]').val('')
        setTimeout(() => {
          $(successMessage).hide(true)
        }, 20000)
      } else {
        $(form).find('button[type="submit"]').attr('aria-busy', 'false')
        alert('Error! Email not subscribed to newsletter. Please try again later.')
      }
    })
  })
})
